import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="mt-auto border-t border-slate-200 px-8 py-3 flex items-center justify-between">
      <p className="text-[10px] text-slate-400">&copy; {new Date().getFullYear()} K-B Corp.</p>
      <div className="flex items-center gap-4">
        <a href="https://k-b.kr" target="_blank" rel="noopener noreferrer" className="text-[10px] text-slate-400 hover:text-primary transition-colors">About</a>
        <Link to="/privacy" className="text-[10px] text-slate-400 hover:text-primary transition-colors">Privacy</Link>
        <Link to="/terms" className="text-[10px] text-slate-400 hover:text-primary transition-colors">Terms</Link>
        <a href="mailto:contact@kbww.kr" className="text-[10px] text-slate-400 hover:text-primary transition-colors">Contact</a>
      </div>
    </footer>
  );
};

export default Footer;
